var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Front',{attrs:{"offsetY":_vm.offsetY}}),_c('About',{attrs:{"id":"zxc1"}}),_c('Video',{attrs:{"offsetY":_vm.offsetY}}),_c('offer',{attrs:{"color":"white"}}),_c('MainImage',{attrs:{"size":_vm.size,"offsetY":_vm.offsetY}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }